import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPageLock: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"page-lock"} maskId="square-filled-radius-0-stroke-1-IconPageLock"><path d="M4 22V2H20V13.3542C19.2671 12.5238 18.1947 12 17 12C15.1362 12 13.5701 13.2748 13.126 15H12V22H4Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M21 16V22H13V16H14C14 14.3431 15.3431 13 17 13C18.6569 13 20 14.3431 20 16H21ZM19 16C19 14.8954 18.1046 14 17 14C15.8954 14 15 14.8954 15 16H19Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPageLock;
